import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import MakeMoneyForm from "../../../component/makeMoneyForm";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";

export default function MakeMoneyManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchMakeMoney = async () => {
    await axiosInstance.get(`/make-money/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/make-money/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      } else {
        await axiosInstance.post(`/make-money/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            fetchMakeMoney();
          });
      }
      navigate("/admin/quan-ly-make-money");
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchMakeMoney();
    form.resetFields();
  }, [form, id]);

  return (
    <MakeMoneyForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
